import i18n from '@/i18n';

const residentGroups = {
  activated: i18n.t('Activated'),
  pending: i18n.t('Pending'),
  deactivated: i18n.t('Deactivated'),
};

export type ResidentGroup = keyof typeof residentGroups;

export default residentGroups;
